type Props = {
  fileExtension?: string;
};
const FileTypeIcon = ({ fileExtension }: Props) => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
    >
      <path
        d="M494.5,138.6L364,3c-1.8-1.9-4.4-3-7-3H162.5c-21.8,0-39.4,17.7-39.5,39.4v137.8H44.3c-16.3,0-29.5,13.2-29.5,29.5v147.8
       c0,16.3,13.2,29.5,29.5,29.5h78.8v88.6c0,21.8,17.7,39.4,39.5,39.4h295.2c21.8,0,39.4-17.6,39.5-39.4V145.4
       C497.2,142.8,496.2,140.4,494.5,138.6z M359.4,26.6l107.1,111.3H359.4V26.6z M44.3,364.3c-5.4,0-9.8-4.4-9.8-9.8V206.7
       c0-5.4,4.4-9.8,9.8-9.8h265.9c5.4,0,9.8,4.4,9.8,9.8v147.7c0,5.4-4.4,9.8-9.8,9.8H44.3z M477.5,472.6c0,10.9-8.9,19.7-19.8,19.7
       H162.5c-10.9,0-19.7-8.8-19.8-19.7V384h167.4c16.3,0,29.5-13.2,29.5-29.5V206.7c0-16.3-13.2-29.5-29.5-29.5H142.8V39.4
       c0-10.9,8.9-19.7,19.8-19.8h177.1v128c0,5.4,4.4,9.9,9.9,9.9l0,0h128V472.6z"
      />
      <text
        style={{
          whiteSpace: "pre",
          fill: "#000",
          fontFamily: "Lars, sans-serif",
          fontSize: 100,
          fontWeight: "bold",
          textTransform: "uppercase",
        }}
        x="55"
        y="315"
      >
        {fileExtension}
      </text>
    </svg>
  );
};

export default FileTypeIcon;
